import { I18nProvider } from '@/i18n';
import { getQueryClient } from '@/lib/react-query';
import { type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import type { FC, PropsWithChildren, ReactElement } from 'react';
import { CookiesProvider } from 'react-cookie';
import { ErrorBoundary } from 'react-error-boundary';
import { AmountUnitProvider } from './AmountUnitProvider';
import { DesignProvider } from './DesignProvider';
import { MessageProvider } from './MessageProvider';
import { PublicSiteStatusProvider } from './PublicSiteStatusProvider';
import { RevisionListenerStatusProvider } from './RevisionListenerStatusProvider';

export const GlobalProvider: FC<
  PropsWithChildren<{
    queryClient?: QueryClient;
    errorFallback?: ReactElement;
  }>
> = ({ queryClient, errorFallback = null, children }) => {
  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient ?? getQueryClient()}>
        <I18nProvider>
          <DesignProvider>
            <MessageProvider>
              <AmountUnitProvider>
                <PublicSiteStatusProvider>
                  <RevisionListenerStatusProvider>
                    <NuqsAdapter>
                      <ErrorBoundary fallback={errorFallback}>
                        {children}
                      </ErrorBoundary>
                    </NuqsAdapter>
                  </RevisionListenerStatusProvider>
                </PublicSiteStatusProvider>
              </AmountUnitProvider>
            </MessageProvider>
          </DesignProvider>
        </I18nProvider>
      </QueryClientProvider>
    </CookiesProvider>
  );
};
